/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('global/Data',[
    'jquery',
    './Logger'
], function ($, Logger) {
    'use strict';

    var Data = {};

    // Object to store multiple responses
    Data._data = {};

    // Requests data asynchronously and fires a callback function.
    // Response is stored in the global scope so the next request with the same parameters
    // will fire callback function with the data stored in the scope.
    function getAsync(options) {
        if (!options.hasOwnProperty('dataType')) {
            options.dataType = 'json';
        }

        var uniqueKey = JSON.stringify(options);

        var cachedPromise = Data._data[uniqueKey];

        if (cachedPromise !== undefined) {

            // if the cache contains our ajax promise, lets see if we're resolved
            if (cachedPromise.state() === 'resolved' && cachedPromise.status === 200) {
                // if we've successfully resolved, trigger the callback immediately
                options.callback(cachedPromise.responseJSON);
                return;

            } else if (cachedPromise.state() === 'pending') {
                // if the promise is still pending, attach an additional callback
                Data._data[uniqueKey] = cachedPromise.always(options.callback);
                return;

            } else {
                // otherwise the request was rejected or was unsuccessful, abort the original promise and perform a new request
                cachedPromise.abort();
            }
        }

        Data._data[uniqueKey] =
            $.ajax(
                {
                    url: options.url,
                    dataType: options.dataType,
                    data: options.data || null,
                    async: true
                }).always(options.callback);
    };

    Data.getAsync = getAsync;

    Logger.debug('Data.js Loaded:', Data);

    return Data;
});

